import React, { useEffect, useState } from 'react';
import useAreasFrameworks from '../../hooks/useAreasFrameworks';
import SDGsImpactField from './SDGsImpactField';

const AreaSDGsImpactField = ({ planUUID, planAreaId, sdgsCount = 10, className = null }) => {
    const { genericFwsRelated } = useAreasFrameworks(
        [{ planUUID: planUUID, planAreaId: planAreaId }]
        ,
        [{ frameworkSuite: 'generic', fwIds: [2]
    }]);
    const [sdgs2030, setSdgs2030] = useState(null);

    useEffect(() => {
        if (planUUID && genericFwsRelated && genericFwsRelated.length == 1 && genericFwsRelated[0].level1sDTOs.length > 0) {
            setSdgs2030(genericFwsRelated[0]);
        } else {
            setSdgs2030(null);
        }
    }, [genericFwsRelated]);

    return (
        <SDGsImpactField
            sdgs2030={sdgs2030}
            sdgsCount={sdgsCount}
            className={className}
        />
    );
};

export default AreaSDGsImpactField;